// extracted by mini-css-extract-plugin
export var author = "post-module--author--f811d";
export var authorsFixed = "post-module--authorsFixed--59d1d";
export var bg = "post-module--bg--d1f24";
export var boxFixed = "post-module--boxFixed--514ad";
export var colContent = "post-module--colContent--64f41";
export var colInfo = "post-module--colInfo--1d74c";
export var conclusion = "post-module--conclusion--19002";
export var content = "post-module--content--46fa6";
export var date = "post-module--date--21bda";
export var imagePost = "post-module--imagePost--7ef14";
export var infoAuthor = "post-module--infoAuthor--cc667";
export var label = "post-module--label--8409c";
export var multiAuthorMobile = "post-module--multiAuthorMobile--9ddfd";
export var multipleAuthor = "post-module--multipleAuthor--09f48";
export var name = "post-module--name--4a501";
export var ol = "post-module--ol--908db";
export var pb = "post-module--pb--d464b";
export var position = "post-module--position--ac338";
export var relatedPosts = "post-module--relatedPosts--5eb74";
export var shareFixed = "post-module--shareFixed--ec7d8";
export var structuredPlayer = "post-module--structuredPlayer--4cdfe";
export var time = "post-module--time--b66a3";
export var topicBd = "post-module--topicBd--ee57e";